module.exports = __webpack_public_path__ + "img/join_3.c5c8ea1e.png";